
export function createSubmitData(formData) {

    let submitData = {
        toJob: formData.toJob,
        truck: formData.truck,

    }
    let logs = []

    formData.equipment.forEach(item => {

        let log = {
            dateAndTime: `${formData.date.format("YYYY-MM-DD")}T${formData.time.format("hh:mm:ss")}`,
            equipment: item.id,
            quantity: item.quantity,
            requestItem: null
        }

        logs.push(log)
    })

    submitData['logs'] = [...logs]

    return submitData
}